export enum FilterTypesContentService {
  SLIDER = "slider",
  SELECT = "select",
  LIST = "list",
}
